export enum GeneralWeightUnits {
  KGS = 'KGS',
  LBS = 'LBS',
}

export enum GeneralVolumeUnits {
  CBM = 'CBM',
  CFT = 'CFT',
}
